import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import isArray from 'lodash-es/isArray';
import PropTypes$1 from 'prop-types';
import React from 'react';
import { PropTypes } from '@panneau/core';
import { useButtonsComponents } from '@panneau/core/contexts';
import Button from '@panneau/element-button';

var styles = {};

var _excluded = ["className", "onClick", "renderButton", "component"];
var propTypes = {
  items: PropTypes.buttons,
  size: PropTypes.buttonSize,
  theme: PropTypes$1.string,
  outline: PropTypes$1.bool,
  renderButton: PropTypes$1.func,
  onClickButton: PropTypes$1.func,
  className: PropTypes$1.string,
  buttonClassName: PropTypes$1.string
};
var defaultProps = {
  items: [],
  size: null,
  theme: null,
  outline: false,
  renderButton: null,
  onClickButton: null,
  className: null,
  buttonClassName: null
};
function Buttons(_ref) {
  var items = _ref.items,
    size = _ref.size,
    theme = _ref.theme,
    outline = _ref.outline,
    renderButton = _ref.renderButton,
    onClickButton = _ref.onClickButton,
    buttonClassName = _ref.buttonClassName,
    className = _ref.className;
  var componentsManager = useButtonsComponents();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['btn-group', _defineProperty({}, "btn-group-".concat(size), size !== null), styles.container, _defineProperty({}, className, className !== null)]),
    role: "group",
    style: {
      zIndex: 0
    }
  }, isArray(items) ? items.map(function (button, index) {
    var _ref4 = button || {},
      _ref4$className = _ref4.className,
      customClassName = _ref4$className === void 0 ? null : _ref4$className,
      _ref4$onClick = _ref4.onClick,
      _onClick = _ref4$onClick === void 0 ? null : _ref4$onClick,
      _ref4$renderButton = _ref4.renderButton,
      customRenderButton = _ref4$renderButton === void 0 ? null : _ref4$renderButton,
      _ref4$component = _ref4.component,
      component = _ref4$component === void 0 ? null : _ref4$component,
      buttonProps = _objectWithoutProperties(_ref4, _excluded);
    var fixedProps = {
      key: "button-".concat(index),
      className: classNames([styles.button, _defineProperty(_defineProperty({}, buttonClassName, buttonClassName !== null), customClassName, customClassName !== null)]),
      theme: theme,
      outline: outline,
      onClick: function onClick(e) {
        if (_onClick !== null) {
          _onClick(e, button, index);
        }
        if (onClickButton !== null) {
          onClickButton(e, button, index);
        }
      }
    };
    var ButtonComponent = component !== null ? componentsManager.getComponent(component) : null;
    if (ButtonComponent !== null) {
      return /*#__PURE__*/React.createElement(ButtonComponent, Object.assign({}, fixedProps, buttonProps));
    }
    var finalRenderButton = customRenderButton || renderButton;
    if (finalRenderButton) {
      return finalRenderButton(button, index, fixedProps);
    }
    return /*#__PURE__*/React.createElement(Button, Object.assign({}, fixedProps, buttonProps));
  }) : null);
}
Buttons.propTypes = propTypes;
Buttons.defaultProps = defaultProps;

export { Buttons as default };
